module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","cargoCarrier":"Cargo Carrier","description":"Description","owner":"Owner","registrationNumber":"Reg.no.","driver":"Driver"},"no":{"add":"Laget","remove":"Slettet","cargoCarrier":"Lastebærer","description":"Beskrivelse","owner":"Eier","registrationNumber":"Reg.nr.","driver":"Sjåfør"}}')
  delete Component.options._Ctor
}
